/* global CONFIG */
import moment from 'moment'
// import services from '../services'
import ft from '../featureToggle'

export default {
  getPackages(VueApp, callback) {
    let self = this
    let laxit = VueApp.$store.state.laxit.tncReservations
    let request = {
      token: VueApp.$store.state.session.sessionToken,
      package: true,
      order: laxit.order,
      orderAsc: laxit.orderAsc,
      pageNum: laxit.currentPage,
      pageSize: laxit.perPage,
      filter: {
        ada: ['all', 'wheelChairLift', 'serviceDog'],
        afterPickupMins: 1440,
        beforePickupMins: 1440,
        bidSource: ['ios', 'android', 'admin', 'ww'],
        defaultGeofenceId: CONFIG.default.laxAirportId,
        defaultPickupAddress: '',
        defaultPickupType: 'airport',
        geofenceIds: CONFIG.default.laxServiceAreaId,
        packageStatus: null,
        rsvpStatus: ['ready', 'upcoming', 'require-dispatch', 'requires_dispatch', 'auto-dispatch', 'auto_dispatch', 'autodispatch'],
        stagingLotIds: [],
        stagingLots: [],
        tripDirection: ['out'],
        assigned: false
      },
      search: laxit.search
    }
    VueApp.$sdk.post('/admin/rsvp/dispatch', request, r => {
      if (!r.error) {
        VueApp.$store.commit('laxit/setTncReservationsMaxList', r.paging.totalItems)

        for (let i = 0; i < r.list.length; i++) {
          if (r.list[i].type === 'rsvp') {
            VueApp.$store.commit('laxit/addTncReservation', self.formatRsvp(VueApp, r.list[i].data))
          } else {
            VueApp.$store.commit('laxit/addTncReservation', self.formatPackage(VueApp, r.list[i].data))
          }
        }

      }

      callback(r)
    })
  },
  getUnrouted(VueApp, callback) {
    let self = this
    let laxit = VueApp.$store.state.laxit.unroutedReservations
    let request = {
      token: VueApp.$store.state.session.sessionToken,
      package: true,
      order: laxit.order,
      orderAsc: laxit.orderAsc,
      pageNum: laxit.currentPage,
      pageSize: laxit.perPage,
      filter: {
        ada: ['all', 'wheelChairLift', 'serviceDog'],
        afterPickupMins: 1440,
        beforePickupMins: 1440,
        bidSource: ['ios', 'android', 'admin', 'ww'],
        defaultGeofenceId: CONFIG.default.laxAirportId,
        defaultPickupAddress: '',
        defaultPickupType: 'airport',
        geofenceIds: CONFIG.default.laxServiceAreaId,
        packageStatus: null,
        rsvpStatus: ['upcoming', 'requires_dispatch', 'waiting_driver', 'dispatched', 'require-dispatch', 'auto-dispatch', 'auto_dispatch', 'autodispatch'],
        stagingLotIds: [],
        stagingLots: [],
        tripDirection: ['out']
      },
      search: laxit.search
    }
    VueApp.$sdk.post('/admin/rsvp/unpackaged', request, r => {
      if (!r.error) {
        VueApp.$store.commit('laxit/setUnroutedReservationsMaxList', r.paging.totalItems)

        for (let i = 0; i < r.list.length; i++) {
          VueApp.$store.commit('laxit/addUnroutedReservation', self.formatRsvp(VueApp, r.list[i]))
        }

      }

      callback(r)
    })
  },
  getOutbound(VueApp, callback) {
    let self = this
    let licenseType = VueApp.$store.state.laxit.driverOutbound.licenseType
    let laxit = VueApp.$store.state.laxit.driverInbound
    switch (licenseType) {
      case 'all':
        licenseType = null
        break
      case 'tnc':
        licenseType = 'tnc'
        break
      case 'tcp':
        licenseType = 'tcp'
        break
    }
    let request = {
      token: VueApp.$store.state.session.sessionToken,
      package: true,
      pageNum: laxit.currentPage,
      pageSize: laxit.perPage,
      order: 'pickupTime',
      filter: {
        ada: ['all', 'wheelChairLift', 'serviceDog'],
        afterPickupMins: 1440,
        beforePickupMins: 1440,
        bidSource: ['ios', 'android', 'admin', 'ww'],
        defaultGeofenceId: CONFIG.default.laxAirportId,
        defaultPickupAddress: '',
        defaultPickupType: 'airport',
        geofenceIds: CONFIG.default.laxServiceAreaId,
        packageStatus: null,
        rsvpStatus: ['onboard', 'dispatched'],
        stagingLotIds: [],
        stagingLots: [],
        tripDirection: ['out'],
        driverLicenseType: licenseType,
      }
    }
    VueApp.$sdk.post('/admin/rsvp/dispatch', request, r => {
      if (!r.error) {
        VueApp.$store.commit('laxit/setDriverOutboundMaxList', r.paging.totalItems)
        for (let i = 0; i < r.list.length; i++) {
          if (r.list[i].type == 'rsvp') {
            VueApp.$store.commit('laxit/addDriverOutbound', self.formatDriverRSVP(VueApp, r.list[i]))
          } else {
            VueApp.$store.commit('laxit/addDriverOutbound', self.formatDriverPKG(VueApp, r.list[i]))
          }
        }
      }

      callback(r)
    })
  },
  getInbound(VueApp, callback) {
    let self = this
    let licenseType = VueApp.$store.state.laxit.driverInbound.licenseType
    let laxit = VueApp.$store.state.laxit.driverInbound
    switch (licenseType) {
      case 'all':
        licenseType = null
        break
      case 'tnc':
        licenseType = 'tnc'
        break
      case 'tcp':
        licenseType = 'tcp'
        break
    }
    let request = {
      token: VueApp.$store.state.session.sessionToken,
      package: true,
      pageNum: laxit.currentPage,
      pageSize: laxit.perPage,
      order: 'etaTime',
      filter: {
        ada: ['all', 'wheelChairLift', 'serviceDog'],
        afterPickupMins: 1440,
        beforePickupMins: 1440,
        bidSource: ['ios', 'android', 'admin', 'ww'],
        defaultGeofenceId: CONFIG.default.laxAirportId,
        defaultPickupAddress: '',
        defaultPickupType: 'airport',
        geofenceIds: CONFIG.default.laxServiceAreaId,
        packageStatus: null,
        rsvpStatus: ['onboard', 'dispatched'],
        stagingLotIds: [],
        stagingLots: [],
        tripDirection: ['in'],
        driverLicenseType: licenseType,
      }
    }
    VueApp.$sdk.post('/admin/rsvp/dispatch', request, r => {
      if (!r.error) {
        VueApp.$store.commit('laxit/setdriverInboundMaxList', r.paging.totalItems)
        for (let i = 0; i < r.list.length; i++) {
          if (r.list[i].type == 'rsvp') {
            VueApp.$store.commit('laxit/adddriverInbound', self.formatDriverRSVP(VueApp, r.list[i]))
          } else {
            VueApp.$store.commit('laxit/adddriverInbound', self.formatDriverPKG(VueApp, r.list[i]))
          }
        }
      }

      callback(r)
    })
  },
  formatRsvp(VueApp, item) {
    let statusClass = item.dispatchStatus
    let status = item.dispatchStatus.toUpperCase()
    if (statusClass === 'requires_dispatch') {
      statusClass = 'requires-dispatch'
      status = 'REQUIRES DISPATCH'
    }

    if (statusClass === 'autodispatch') {
      statusClass = 'auto-dispatch'
      status = 'AUTO DISPATCH'
    }

    if (statusClass === 'complete') {
      status = 'COMPLETED'
    }

    if (statusClass === 'ready') {
      status = 'READY TO GO'
    }

    if (item.status === 'ontheway') {
      statusClass = 'ontheway'
      status = 'ONTHEWAY'
    }

    let phoneNumber = null
    if (item.consumer.phones && item.consumer.phones.length > 0) {
      let phone = item.consumer.phones[0]
      phoneNumber = '+' + phone.countryCode + phone.phoneNumber
    }

    let pickup = {
      address1: item.pickupLocation.addressLine1,
      address2: item.pickupLocation.addressLine2,
      city: item.pickupLocation.city,
      state: item.pickupLocation.state,
      zip: item.pickupLocation.zip,
      lat: item.pickupLocation.lat,
      lng: item.pickupLocation.lng,
      geofenceType: item.pickupLocation.geofenceType,
      geofenceName: item.pickupLocation.geofenceName,
      title: item.pickupLocation.title
    }
    let dropoff = {
      address1: item.dropoffLocation.addressLine1,
      address2: item.dropoffLocation.addressLine2,
      city: item.dropoffLocation.city,
      state: item.dropoffLocation.state,
      zip: item.dropoffLocation.zip,
      lat: item.dropoffLocation.lat,
      lng: item.dropoffLocation.lng,
      geofenceType: item.dropoffLocation.geofenceType,
      geofenceName: item.dropoffLocation.geofenceName,
      title: item.dropoffLocation.title
    }
    let pickupMoment = moment(item.pickupDate, 'YYYY-MM-DD hh:mm:ss')
    let threshold = VueApp.$store.state.routing.beThereTimeThreshold
    let maxDuration = Math.floor(item.etaInSec * threshold)
    let btt = pickupMoment.add(maxDuration, 'seconds')

    let legs = [] // stops
    legs.push({
      originalBTT: 0,
      eta: 0,
      inOrder: -1,
      isPickup: true,
      location: pickup,
      passengers: item.passengers,
      luggage: item.luggage !== null ? item.luggage : 0,
      maxDuration: 0,
      packageID: null,
      pickupTime: moment(item.pickupDate, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
      originalPickupTime: moment(item.pickupDate, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
      reservationID: item.ID,
      status: status
    })
    legs.push({
      originalBTT: maxDuration,
      eta: item.etaInSec,
      inOrder: -1,
      isPickup: false,
      location: dropoff,
      passengers: item.passengers,
      luggage: item.luggage !== null ? item.luggage : 0,
      maxDuration: maxDuration,
      packageID: null,
      pickupTime: moment(item.pickupDate, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
      originalPickupTime: moment(item.pickupDate, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
      reservationID: item.ID,
      status: status
    })

    let flightName = item.airline
    let flightNumber = item.flightNumber
    let airlineCode = item.airlineCode
    let dropoffAirline = ''
    let dropoffFlightNumber = ''
    if (item.dropoffAirline || item.dropoffFlightNumber) {
      dropoffAirline = item.dropoffAirline
      airlineCode = item.dropoffAirlineCode
      dropoffFlightNumber = item.dropoffFlightNumber
    }
    let sector = item.pickupLocation.sectors || item.pickupLocation.city
    let serviceType = {
      label: '',
      color: ''
    }
    if (item.serviceType) {
      serviceType = {
        label: item.serviceType.label,
        color: item.serviceType.color
      }
    }
    return {
      id: item.ID,
      type: 'rsvp',
      statusClass: statusClass,
      status: status,
      pickupTime: moment(item.pickupDate, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
      pickup: pickup,
      eta: item.etaInSec,
      beThereTime: btt.format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
      dropoff: dropoff,
      customer: {
        id: item.consumer.ID,
        firstName: item.consumer.firstName,
        lastName: item.consumer.lastName,
        phone: phoneNumber
      },
      flight: {
        airline: flightName || dropoffAirline,
        airlineCode: airlineCode,
        flightNumber: flightNumber || dropoffFlightNumber
      },
      airline: flightName,
      airlineCode: airlineCode,
      airportCode: item.airportCode,
      flightNumber: flightNumber,
      dropoffAirline: dropoffAirline,
      dropoffFlightNumber: dropoffFlightNumber,
      passengers: item.passengers,
      luggage: item.luggage !== null ? item.luggage : 0,
      payment: item.payment,
      legs: legs,
      ada: {
        wheelchair: item.ada.wheelChairLift === 1,
        serviceDog: item.ada.serviceDog === 1
      },
      pickupSectors: item.pickupLocation.sectors ? item.pickupLocation.sectors : null,
      dropoffSectors: item.dropoffLocation.sectors ? item.dropoffLocation.sectors : null,
      sector: sector,
      serviceType: serviceType,
      notes: item.notes
    }
  },
  formatPackage(VueApp, item) {
    let self = this
    // Status
    let statusClass = item.package.packageStatus
    let status = item.package.packageStatus.toUpperCase()
    if (statusClass === 'requires_dispatch') {
      statusClass = 'requires-dispatch'
      status = 'REQUIRES DISPATCH'
    }
    if (statusClass === 'autodispatch') {
      statusClass = 'auto-dispatch'
      status = 'AUTO DISPATCH'
    }
    if (statusClass === 'complete') {
      status = 'COMPLETED'
    }
    if (statusClass === 'ready') {
      status = 'READY TO GO'
    }

    // RSVP
    let ada = {
      serviceDog: 0,
      wheelChairLift: 0
    }
    let notes = []
    for (let i = 0; i < item.rsvp.length; i++) {
      let rsvp = item.rsvp[i]
      if (rsvp.notes !== null) {
        notes.push({
          rsvpID: rsvp.ID,
          notes: rsvp.notes
        })
      }
    }
    let rsvps = []
    let luggage = 0
    let tip = 0
    for (let i = 0; i < item.rsvp.length; i++) {
      let rsvp = self.formatRsvp(VueApp, item.rsvp[i])
      luggage += rsvp.luggage
      rsvps.push(rsvp)
      if (rsvp.ada.wheelchair) {
        ada.wheelchair = true
      }
      if (rsvp.ada.serviceDog) {
        ada.serviceDog = true
      }
      tip = tip + rsvp.payment.tipAmount
    }

    let legs = []
    for (let i = 0; i < item.stops.length; i++) {
      let leg = item.stops[i]
      let itemRsvp = rsvps.filter(rsvp => rsvp.id === leg.reservationID)[0]
      legs.push({
        originalBTT: itemRsvp.legs[1].maxDuration,
        eta: leg.eta,
        inOrder: leg.inOrder,
        isPickup: leg.isPickup,
        location: leg.isPickup ? itemRsvp.pickup : itemRsvp.dropoff,
        passengers: itemRsvp.passengers,
        luggage: itemRsvp.luggage !== null ? itemRsvp.luggage : 0,
        maxDuration: leg.maxDuration,
        packageID: item.package.id,
        pickupTime: moment(item.package.localPickupTime, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
        originalPickupTime: moment(itemRsvp.pickupTime, 'MM/DD/YYYY hh:mmA').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
        reservationID: leg.reservationID,
        status: itemRsvp.status
      })
    }
    let serviceType = {
      label: '',
      color: ''
    }
    if (rsvps[0] && rsvps[0].serviceType) {
      serviceType = {
        label: rsvps[0].serviceType.label,
        color: rsvps[0].serviceType.color
      }
    }

    return {
      id: item.package.id,
      type: 'package',
      status: status,
      statusClass: statusClass,
      sector: item.dropoffSector.name || '',
      pickupTime: moment(item.package.localPickupTime, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
      firstPickup: item.package.firstPickup,
      lastPickup: item.package.lastPickup,
      driver: item.driver,
      payment: item.package.paidForProvider,
      bonus: item.package.bonusToProvider,
      tip: tip,
      ada: ada,
      stops: item.package.stops,
      passengers: item.package.pax,
      luggage: luggage,
      rsvps: rsvps,
      legs: legs,
      inPool: item.package.inPool === 1,
      serviceType: serviceType,
      notes: notes
    }
  },
  formatDriverRSVP(VueApp, item) {
    let driverName = ''
    if (item.data.provider.firstName) {
      driverName = item.data.provider.firstName + ' ' + item.data.provider.lastName
    }
    return {
      reservationID: item.data.ID,
      id: item.data.provider.ID,
      name: driverName,
      pax: item.data.passengers,
      eta: moment(item.data.pickupDate, 'YYYY-MM-DD hh:mm:ss').add(item.data.etaInSec, 'seconds').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
      pickupTime: moment(item.data.pickupDate, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false))
    }
  },
  formatDriverPKG(VueApp, item) {
    let driverName = ''
    if (item.data.driver.firstName) {
      driverName = item.data.driver.firstName + ' ' + item.data.driver.lastName
    }
    return {
      reservationID: item.data.rsvp[0].ID,
      id: item.data.driver.ID,
      name: driverName,
      pax: item.data.rsvp[0].passengers,
      eta: moment(item.data.rsvp[0].pickupDate, 'YYYY-MM-DD hh:mm:ss').add(item.data.rsvp[0].etaInSec, 'seconds').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
      pickupTime: moment(item.data.rsvp[0].pickupDate, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false))
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/laxit/reservations.js